import {IComponentOptions} from "angular";
import {getEditableFieldConfiguration} from "../editable-field.component";
import {IEditableField} from "../IEditableField";


export class CurrencyEditableField extends IEditableField {

    public static instance: IComponentOptions = getEditableFieldConfiguration(
        require('./currency-editable-field.html'),
        [CurrencyEditableField]
    );

    static readonly DEFAULT_CURRENCY_PATTERN = '[\\d\\.]+';
    static readonly DEFAULT_ERROR_MESSAGE = 'Should be a number';

    $onInit() {
        this.pattern = CurrencyEditableField.DEFAULT_CURRENCY_PATTERN;
        this.errorMessage = CurrencyEditableField.DEFAULT_ERROR_MESSAGE;
    }

}